import { Navigate } from 'react-router-dom'

import AuthGuard from '../../auth/AuthGuard'
import MatxLayout from '../base/components/Template/MatxLayout/MatxLayout'
import cuentaRoutes from '../modules/base/cuenta/CuentaRoutes'
import NotFound from '../modules/base/sessions/NotFound'
import sessionRoutes from '../modules/base/sessions/SessionRoutes'
import catalogosRoutes from '../modules/catalogos/CatalogosRoutes'
import configuracionRoutes from '../modules/configuracion/ConfiguracionRoutes'
import CafcRoutes from '../modules/empresa/modules/cafc/CafcRoutes'
import emailRoutes from '../modules/empresa/modules/email/EmailRoutes'
import licenciaRoutes from '../modules/empresa/modules/licencia/LicenciaRoutes'
import firmaDigitalRoutes from '../modules/firmaDigital/firmaDigitalRoutes'
import homeRoutes, { homeRoutesMap } from '../modules/home/HomeRoutes'
import logoRoutes from '../modules/logo/logoRoutes'
import monedaRoutes from '../modules/moneda/MonedaRoutes'
import previsualizacionRoutes from '../modules/previsualizacion/PrevisualizacionRoutes'
import puntoVentaRoutes from '../modules/puntoVenta/PuntoVentaRoutes'
import rolesRoutes from '../modules/roles/RolesRoutes'
import SucursalRoutes from '../modules/sucursal/SucursalRoutes'
import usuarioRoutes from '../modules/usuarios/UsuarioRoutes'

export const appRoutes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...homeRoutes,
      ...cuentaRoutes,
      ...rolesRoutes,
      ...usuarioRoutes,
      ...licenciaRoutes,
      ...emailRoutes,
      ...SucursalRoutes,
      ...puntoVentaRoutes,
      ...monedaRoutes,
      ...firmaDigitalRoutes,
      ...logoRoutes,
      ...configuracionRoutes,
      ...catalogosRoutes,
      ...previsualizacionRoutes,
      ...CafcRoutes,
    ],
  },
  ...sessionRoutes,
  { path: '/', element: <Navigate to={homeRoutesMap.home.path} /> },
  {
    path: '*',
    element: <NotFound />,
  },
]
